export type AKLIOLegalBlock =
  | { type: 'paragraph'; text: string }
  | { type: 'table'; rows: string[][] };

export interface AKLIOLegalDocument {
  slug: string;
  navLabel: string;
  title: string;
  subtitle: string;
  effectiveDate: string;
  description: string;
  blocks: AKLIOLegalBlock[];
}

export const aklioLegalDocuments: AKLIOLegalDocument[] = [
    {
        "slug":  "terminos-condiciones",
        "navLabel":  "Terminos y condiciones",
        "title":  "Terminos y Condiciones de Uso",
        "subtitle":  "Plataforma de Gestion Medica AKLIO",
        "effectiveDate":  "30 de junio de 2025",
        "description":  "Condiciones que regulan el acceso, uso, pagos, responsabilidades y propiedad intelectual de AKLIO.",
        "blocks":  [
                       {
                           "type":  "paragraph",
                           "text":  "1. Identificación del Prestador del Servicio"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El presente documento establece los Términos y Condiciones que regulan el acceso y uso de la plataforma AKLIO, desarrollada y administrada por THE BLUE CODING S.A.S (en adelante \"La Empresa\"), constituida bajo las leyes de la República del Ecuador. Correo de contacto legal: legal@thebluecoding.com · Sitio web: https://thebluecoding.com/aklio"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Estos términos tienen validez jurídica conforme al Art. 2 de la Ley de Comercio Electrónico, Firmas Electrónicas y Mensajes de Datos del Ecuador, que reconoce igual valor jurídico a los documentos escritos y a los mensajes de datos. Al registrarse y acceder a la plataforma, el Usuario declara haber leído, comprendido y aceptado estos Términos en su totalidad."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "2. Objeto del Servicio"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "AKLIO es una plataforma digital SaaS (Software as a Service) de gestión médica que permite a profesionales de la salud y establecimientos de atención médica (en adelante \"el Usuario\") administrar agendas de citas, fichas médicas digitales y registros de atención a pacientes, con el fin de eliminar el uso de papel y mejorar la eficiencia operativa de su práctica médica."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La Empresa actúa exclusivamente como proveedor tecnológico que facilita la plataforma. El Usuario es el responsable del uso que realice de ella y de la información que ingrese en el sistema."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "3. Requisitos de Acceso — Validación de Título Profesional"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El acceso a la plataforma está restringido exclusivamente a profesionales de la salud con título legalmente reconocido en Ecuador. Es condición indispensable para el registro:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Poseer un título profesional de salud debidamente registrado ante las autoridades competentes del Ecuador."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La validación se realiza de manera automática mediante consulta a las APIs públicas del Sistema de Acreditación de Carreras y Certificación de Estándares (SACCS) u otros registros públicos oficiales equivalentes vigentes."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "En caso de que el título no pueda verificarse mediante dichas APIs públicas, el Usuario deberá presentar documentos físicos o digitales que acrediten la validez de su título. Dichos documentos deberán estar debidamente apostillados conforme al Convenio de La Haya para ser considerados válidos."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El Usuario que proporcione información falsa o documentación adulterada para acceder al sistema será responsable civil y penalmente conforme a la legislación ecuatoriana vigente."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La Empresa se reserva el derecho de suspender o cancelar el acceso de cualquier cuenta cuya titulación no pueda ser verificada o haya sido obtenida mediante información fraudulenta, sin que ello genere derecho a reembolso."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "4. Disponibilidad del Servicio y Exoneración de Responsabilidad"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "AKLIO opera sobre infraestructura tecnológica de terceros (proveedores de nube, servicios de alojamiento, bases de datos, redes de comunicación, entre otros). La disponibilidad del servicio depende en parte de dichos terceros, sobre los cuales La Empresa no tiene control total."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La Empresa realizará sus mejores esfuerzos para mantener la plataforma disponible de forma continua y notificará con antelación razonable las interrupciones programadas por mantenimiento. Sin embargo, el Usuario reconoce y acepta expresamente que:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "No se puede garantizar disponibilidad del servicio al 100%."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Pueden producirse interrupciones temporales por mantenimiento, actualizaciones, fallos técnicos de terceros, casos fortuitos o fuerza mayor."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Al aceptar estos Términos, el Usuario renuncia expresamente a cualquier acción legal, queja, denuncia o reclamación económica derivada de la indisponibilidad temporal o permanente del servicio, ya sea total o parcial, cuando dicha indisponibilidad se origine en fallas de infraestructura de terceros o causas ajenas al control directo de La Empresa."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "5. Facturación, Pagos, Suspensión y Eliminación de Datos"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El acceso a AKLIO está sujeto al pago de una tarifa periódica según el plan contratado. Las condiciones son las siguientes:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El Usuario debe realizar el pago en las fechas de corte acordadas al momento de la contratación."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Se concede un período de gracia máximo de dos (2) días calendario posteriores a la fecha de corte para regularizar el pago pendiente."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Transcurridos los dos días de gracia sin que se haya efectuado el pago, el servicio será suspendido automáticamente. Durante el período de suspensión no se podrá acceder a la plataforma ni a los datos almacenados."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La información del Usuario permanecerá almacenada durante un período máximo de tres (3) meses calendario contados desde la fecha de suspensión."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Si al término de los tres meses el Usuario no ha regularizado su situación de pago, La Empresa procederá a la eliminación definitiva e irreversible de todos los datos asociados a esa cuenta, sin que sea obligación de La Empresa conservar dicha información."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La Empresa no asume responsabilidad alguna por la pérdida de información derivada de la eliminación de datos por falta de pago. El Usuario es el único responsable de mantener su suscripción vigente y de exportar su información cuando lo considere necesario."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Política de reembolsos: Los pagos realizados no son reembolsables una vez iniciado el período facturado, salvo error de cargo demostrable mediante solicitud formal escrita dirigida a legal@thebluecoding.com dentro de los cinco (5) días hábiles siguientes al cargo. La Empresa evaluará cada caso y comunicará su resolución en un plazo máximo de diez (10) días hábiles."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "6. Responsabilidad del Usuario y Uso Aceptable"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El Usuario es el único responsable del uso que realice de la plataforma y de la información que ingrese. En particular, el Usuario se compromete a:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Utilizar la plataforma exclusivamente para fines legales y dentro del marco de su ejercicio profesional médico."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Mantener la confidencialidad de sus credenciales de acceso. La Empresa no será responsable por accesos no autorizados derivados de negligencia del Usuario en la custodia de sus credenciales."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Garantizar la seguridad de los equipos, dispositivos y redes desde los cuales accede a la plataforma. La Empresa no será responsable por filtraciones de información causadas por vulnerabilidades en los equipos del Usuario, ataques a su red, malware, spyware u otras amenazas en el entorno del propio Usuario."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "No compartir sus credenciales con personas no autorizadas."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Notificar de inmediato a La Empresa ante cualquier sospecha de uso no autorizado de su cuenta."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Obtener el consentimiento informado de sus pacientes para el tratamiento digital de sus datos clínicos, conforme a la normativa sanitaria y de protección de datos vigente en Ecuador."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "7. Limitación de Responsabilidad"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "En la máxima medida permitida por la ley ecuatoriana:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La Empresa no será responsable por daños directos, indirectos, incidentales, especiales o consecuentes derivados del uso o imposibilidad de uso de la plataforma."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La Empresa no será responsable por el mal uso de la información ingresada por el Usuario o por terceros con acceso a los equipos del Usuario."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La Empresa no se responsabiliza por la pérdida, alteración o robo de datos producida en el entorno tecnológico del Usuario."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La responsabilidad total de La Empresa, en caso de prosperar algún reclamo, se limitará al monto pagado por el Usuario en los últimos tres (3) meses de servicio."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "8. Propiedad Intelectual"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Todos los derechos de propiedad intelectual sobre la plataforma AKLIO, incluyendo código fuente, diseño, logotipos, marcas registradas y documentación, son propiedad exclusiva de THE BLUE CODING S.A.S. El Usuario obtiene únicamente una licencia de uso limitada, personal, no exclusiva, intransferible y revocable."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Queda expresamente prohibido copiar, modificar, distribuir, vender, sublicenciar o realizar ingeniería inversa sobre cualquier componente de la plataforma."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "9. Modificaciones a los Términos"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La Empresa se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento, notificando al Usuario con al menos quince (15) días de anticipación mediante correo electrónico o aviso dentro de la plataforma. El uso continuado del servicio tras la notificación implica la aceptación de los nuevos términos. Si el Usuario no acepta los cambios, deberá cancelar su suscripción antes de la fecha de entrada en vigencia."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "10. Legislación Aplicable y Resolución de Disputas"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Estos Términos se rigen por las leyes de la República del Ecuador, incluyendo la Ley de Comercio Electrónico, Firmas Electrónicas y Mensajes de Datos, la Ley Orgánica de Protección de Datos Personales y demás normativa aplicable."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Toda controversia que no pueda resolverse de forma amigable entre las partes en un plazo de treinta (30) días desde la notificación escrita del conflicto, será sometida a resolución arbitral ante un Tribunal de la Cámara de Comercio de Quito, conforme a la Ley de Arbitraje y Mediación del Ecuador, con las siguientes condiciones:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El tribunal estará conformado por un (1) árbitro seleccionado conforme al reglamento de la Cámara."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El procedimiento será confidencial y el tribunal fallará en derecho."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Las partes renuncian a la jurisdicción ordinaria para estos efectos."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Las acciones de naturaleza penal se resolverán ante los jueces competentes conforme al Código Orgánico Integral Penal."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "11. Contacto"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Consultas legales: legal@thebluecoding.com"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Protección de datos: lopd@thebluecoding.com"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Sitio web: https://thebluecoding.com/aklio"
                       }
                   ]
    },
    {
        "slug":  "privacidad-datos",
        "navLabel":  "Privacidad y datos",
        "title":  "Politica de Confidencialidad y Proteccion de Datos Personales",
        "subtitle":  "Conforme a la LOPDP del Ecuador",
        "effectiveDate":  "30 de junio de 2025",
        "description":  "Politica sobre tratamiento, confidencialidad, seguridad, conservacion y derechos de titulares de datos personales.",
        "blocks":  [
                       {
                           "type":  "paragraph",
                           "text":  "1. Identificación del Responsable del Tratamiento"
                       },
                       {
                           "type":  "table",
                           "rows":  [
                                        [
                                            "Campo",
                                            "Información"
                                        ],
                                        [
                                            "Empresa",
                                            "THE BLUE CODING S.A.S"
                                        ],
                                        [
                                            "Producto",
                                            "AKLIO"
                                        ],
                                        [
                                            "RUC",
                                            "1793228515001"
                                        ],
                                        [
                                            "Domicilio",
                                            "Gaspar de Villaroel y Chimborazo S2-90, Quito, Ecuador"
                                        ],
                                        [
                                            "Representante Legal",
                                            "Pablo Santacruz"
                                        ],
                                        [
                                            "Correo LOPD",
                                            "lopd@thebluecoding.com"
                                        ],
                                        [
                                            "Correo Legal",
                                            "legal@thebluecoding.com"
                                        ],
                                        [
                                            "Sitio Web",
                                            "https://thebluecoding.com/aklio"
                                        ]
                                    ]
                       },
                       {
                           "type":  "paragraph",
                           "text":  "En el marco de la LOPDP, THE BLUE CODING S.A.S actúa en calidad de Encargado del Tratamiento de los datos personales de los pacientes ingresados en la plataforma, procesándolos únicamente bajo instrucciones del Usuario (el profesional de salud o clínica), quien actúa como Responsable del Tratamiento. Para los datos del propio Usuario (médico/clínica suscriptor), The Blue Coding actúa como Responsable."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "2. Marco Normativo"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Esta política tiene su fundamento en:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Ley Orgánica de Protección de Datos Personales (LOPDP) del Ecuador y su Reglamento General."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Ley de Comercio Electrónico, Firmas Electrónicas y Mensajes de Datos del Ecuador."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Ley Orgánica de Salud y demás normativa sanitaria aplicable."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Código Orgánico Integral Penal (COIP) en lo relativo a delitos informáticos."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "3. Datos que se Recopilan"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "A través de AKLIO se pueden tratar los siguientes tipos de datos:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Datos de identificación del Usuario profesional: nombre completo, número de cédula/RUC, número de registro de título profesional, correo electrónico, número de teléfono, datos de facturación."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Datos de pacientes ingresados por el Usuario: información de identificación, datos de salud, historial de consultas, diagnósticos, tratamientos y demás información clínica que el Usuario decida registrar. Estos constituyen datos sensibles conforme al Art. 26 de la LOPDP y reciben protección reforzada."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Datos de uso de la plataforma: registros de acceso, direcciones IP, tipo de dispositivo y navegador, interacciones con el sistema (con fines de seguridad y mejora del servicio)."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Datos de menores de edad: cuando el Usuario (p. ej. pediatra) ingrese datos de pacientes menores de 18 años, estos recibirán el nivel máximo de protección. El consentimiento para su tratamiento deberá ser otorgado por el representante legal del menor, conforme al Art. 21 de la LOPDP y el Código de la Niñez y Adolescencia."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "4. Finalidades del Tratamiento"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Los datos personales son tratados exclusivamente para las siguientes finalidades:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Provisión de las funcionalidades de gestión de agenda y fichas médicas digitales de la plataforma."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Garantizar el correcto funcionamiento técnico, la seguridad y la integridad de la plataforma."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Gestión de la relación contractual entre el Usuario y La Empresa (facturación, soporte técnico, notificaciones del servicio)."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cumplimiento de obligaciones legales y atención de requerimientos de autoridades competentes cuando corresponda por mandato legal expreso."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Bajo ninguna circunstancia La Empresa utilizará los datos almacenados con fines comerciales, publicitarios, de marketing, ni para compartirlos con terceros con finalidades ajenas a la prestación del servicio contratado."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "5. Declaración Expresa de No Comercialización de Datos"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "The Blue Coding declara de forma expresa e irrevocable que:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "No venderá, arrendará, cederá, intercambiará ni transferirá los datos personales de los pacientes ni del Usuario a ningún tercero con fines comerciales."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "No utilizará los datos de los pacientes para elaborar perfiles comerciales, estadísticas de mercado con fines lucrativos, ni para ningún otro propósito ajeno al servicio contratado."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "No compartirá datos con aseguradoras, laboratorios, empresas farmacéuticas ni ninguna otra entidad del sector salud o fuera de él, salvo mandato legal expreso."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Los datos almacenados en AKLIO son de propiedad exclusiva del Usuario y de los titulares de dichos datos (los pacientes). The Blue Coding actúa únicamente como custodio técnico de esa información."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "6. Base Legal del Tratamiento"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Ejecución de contrato: necesario para la prestación del servicio contratado por el Usuario (Art. 7.1 LOPDP)."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Consentimiento: para datos de pacientes, el Usuario debe haber obtenido consentimiento informado conforme a la normativa sanitaria aplicable. Esta responsabilidad recae exclusivamente en el Usuario."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cumplimiento de obligación legal: cuando sea requerido por autoridades competentes mediante requerimiento formal."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "7. Responsabilidades del Usuario como Responsable del Tratamiento"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El Usuario, en calidad de Responsable del Tratamiento, asume las siguientes obligaciones:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Obtener el consentimiento válido de sus pacientes para el tratamiento digital de sus datos personales y de salud, mediante casilla desmarcada por defecto u otro mecanismo que refleje voluntad libre, específica, informada e inequívoca."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Informar a sus pacientes sobre el uso de una plataforma digital para el registro de su información clínica."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Garantizar la exactitud, actualización y pertinencia de los datos ingresados."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Responder ante sus pacientes y ante la Autoridad de Protección de Datos Personales (APDP) por el correcto ejercicio de sus derechos como titulares."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Custodiar adecuadamente las credenciales de acceso y garantizar que solo personal autorizado acceda al sistema."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Para pacientes menores de edad: obtener el consentimiento del representante legal y cumplir con lo establecido en el Código de la Niñez y Adolescencia del Ecuador."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "8. Deslinde de Responsabilidad por Seguridad en el Entorno del Usuario"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La Empresa no será responsable por:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Filtraciones, accesos no autorizados o pérdidas de datos causadas por vulnerabilidades, malware, virus u otras amenazas presentes en los equipos, redes o entornos tecnológicos del propio Usuario."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El acceso indebido a la plataforma por terceros que hayan obtenido las credenciales del Usuario mediante engaño, robo o cualquier medio ajeno al control de La Empresa."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El uso indebido de la información por parte del propio Usuario, sus colaboradores o cualquier persona con acceso autorizado o no a la cuenta."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La inadecuada configuración de seguridad en los dispositivos del Usuario."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El Usuario asume plena responsabilidad por la seguridad de su entorno tecnológico y las consecuencias derivadas de la falta de medidas adecuadas de protección en sus equipos y redes."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "9. Medidas de Seguridad Implementadas por La Empresa"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "The Blue Coding adopta las siguientes medidas técnicas y organizativas para proteger los datos:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cifrado de datos en tránsito mediante protocolos seguros TLS/SSL."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cifrado de datos en reposo para información sensible de salud."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Control de acceso basado en roles (RBAC) con autenticación segura."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Copias de seguridad (backups) periódicas con verificación de integridad."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Monitoreo continuo de la infraestructura para detectar accesos no autorizados o actividad anómala."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Actualizaciones de seguridad regulares en todos los componentes de la plataforma."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Evaluaciones periódicas de vulnerabilidades y pruebas de seguridad."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La Empresa reconoce que ninguna medida de seguridad informática es absolutamente infalible, y trabajará de manera diligente para mantener los estándares más altos posibles."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "10. Conservación de Datos"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Los datos se conservarán durante la vigencia del contrato y, tras su finalización, durante los siguientes plazos mínimos exigidos por la normativa ecuatoriana:"
                       },
                       {
                           "type":  "table",
                           "rows":  [
                                        [
                                            "Materia",
                                            "Plazo mínimo de conservación"
                                        ],
                                        [
                                            "Civil (contratos, obligaciones)",
                                            "11 años"
                                        ],
                                        [
                                            "Tributaria (facturas, declaraciones)",
                                            "8 años"
                                        ],
                                        [
                                            "Comercio (libros contables)",
                                            "7 años"
                                        ],
                                        [
                                            "Datos de salud (historia clínica)",
                                            "Conforme normativa MSP vigente"
                                        ],
                                        [
                                            "Datos de pacientes fallecidos",
                                            "10 años desde la fecha de fallecimiento"
                                        ]
                                    ]
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Sin perjuicio de lo anterior, conforme a lo establecido en los Términos y Condiciones, los datos de cuentas suspendidas por falta de pago serán eliminados al cumplirse 3 meses desde la suspensión, salvo que exista obligación legal de conservación por mayor tiempo."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "11. Transferencias Internacionales de Datos"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Los datos almacenados en AKLIO podrían ser procesados en servidores ubicados fuera del Ecuador, en el marco de los servicios de infraestructura en la nube utilizados por La Empresa. En tal caso, La Empresa garantiza que dichas transferencias se realizan conforme a la LOPDP y sus reglamentos, adoptando las salvaguardas contractuales y técnicas adecuadas para proteger los datos."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "12. Derechos de los Titulares (Derechos ARCO+)"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Los titulares de datos personales tienen derecho a ejercer los siguientes derechos conforme a la LOPDP:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Acceso: conocer qué datos suyos están siendo tratados y con qué finalidad."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Rectificación: solicitar la corrección de datos inexactos o incompletos."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cancelación/Supresión: solicitar la eliminación de datos cuando no exista causa legal que justifique su conservación."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Oposición: oponerse al tratamiento en determinadas circunstancias."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Portabilidad: recibir sus datos en formato estructurado y de uso común."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Limitación del tratamiento: solicitar la restricción del tratamiento en ciertos supuestos."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "No ser objeto de decisiones automatizadas: cuando estas produzcan efectos jurídicos significativos."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Para ejercer cualquiera de estos derechos, el titular debe enviar su solicitud a lopd@thebluecoding.com indicando el derecho a ejercer, adjuntando copia de su documento de identidad. La Empresa responderá en los plazos establecidos por la LOPDP."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El ejercicio de estos derechos es gratuito."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "13. Notificación de Brechas de Seguridad"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "En caso de producirse una brecha de seguridad en la infraestructura de La Empresa que pueda afectar datos personales, La Empresa notificará a los Usuarios afectados y a la Autoridad de Protección de Datos Personales (APDP) en los plazos establecidos por la LOPDP."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "14. Autoridad de Control"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La autoridad de control en materia de protección de datos en Ecuador es la Autoridad de Protección de Datos Personales (APDP). Los titulares que consideren vulnerados sus derechos pueden presentar reclamación ante dicha autoridad."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "15. Aceptación y Consentimiento"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Al registrarse en la plataforma, el Usuario acepta esta política mediante una casilla de verificación que aparece desmarcada por defecto, lo que constituye un acto afirmativo que refleja la plena y libre voluntad del titular. La Empresa conservará el registro del consentimiento para efectos de demostración ante la autoridad competente."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "16. Modificaciones"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Esta política puede actualizarse para adaptarse a cambios normativos, tecnológicos o de negocio. Las modificaciones serán notificadas con al menos quince (15) días de anticipación. El uso continuado de la plataforma tras la notificación implica aceptación de los cambios."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "17. Contacto"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Delegado de Protección de Datos (LOPD): lopd@thebluecoding.com"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Consultas legales: legal@thebluecoding.com"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Sitio web: https://thebluecoding.com/aklio"
                       }
                   ]
    },
    {
        "slug":  "cookies",
        "navLabel":  "Politica de cookies",
        "title":  "Politica de Cookies",
        "subtitle":  "Uso de cookies y tecnologias similares en AKLIO",
        "effectiveDate":  "30 de junio de 2025",
        "description":  "Informacion sobre tipos de cookies, finalidades, consentimiento, duracion y gestion de preferencias.",
        "blocks":  [
                       {
                           "type":  "paragraph",
                           "text":  "En cumplimiento de la Ley Orgánica de Protección de Datos Personales (LOPDP) del Ecuador y su Reglamento, se informa al usuario sobre el uso de cookies en la plataforma AKLIO."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "1. ¿Qué son las Cookies?"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Las cookies y otras tecnologías similares (como píxeles, almacenamiento local o identificadores de sesión) son pequeños archivos de texto o elementos de datos que se almacenan en el dispositivo del usuario cuando accede a una página web o plataforma digital. Permiten que el sistema recuerde información sobre la visita del usuario para facilitar su experiencia de uso y garantizar el correcto funcionamiento del servicio."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "2. Cookies que Requieren Consentimiento"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Conforme a la normativa ecuatoriana, únicamente las cookies técnicas y estrictamente necesarias para el funcionamiento del servicio están exentas de requerir consentimiento previo. Las demás categorías requieren autorización expresa del usuario mediante casilla de aceptación desmarcada por defecto."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "3. Tipos de Cookies Según su Finalidad"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cookies técnicas y funcionales (siempre activas): Imprescindibles para el funcionamiento básico de la plataforma. Permiten la autenticación, el mantenimiento de sesión y la navegación entre secciones. No pueden deshabilitarse sin afectar el servicio."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cookies analíticas y de rendimiento: Permiten conocer cómo interactúan los usuarios con la plataforma — páginas visitadas, funcionalidades más usadas, errores detectados. La información recopilada es anónima y se usa exclusivamente para mejorar el servicio."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cookies de preferencias: Almacenan configuraciones del usuario como idioma preferido, zona horaria u otras personalizaciones de la interfaz para ofrecer una experiencia más personalizada."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cookies de seguridad: Detectan actividad sospechosa, previenen accesos no autorizados y protegen la integridad de la sesión del usuario."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cookies publicitarias: AKLIO no utiliza cookies publicitarias propias. En caso de integrar herramientas de terceros que instalen este tipo de cookies, se informará expresamente al usuario y se requerirá su consentimiento previo."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "4. Tipos de Cookies Según su Propiedad"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cookies propias: Generadas y gestionadas directamente por The Blue Coding desde los servidores de AKLIO."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cookies de terceros: Generadas por proveedores externos integrados en la plataforma (infraestructura en la nube, servicios de analítica, herramientas de autenticación). Estas cookies están sujetas a las políticas de privacidad de cada proveedor externo, sobre las cuales La Empresa no tiene control directo. Se recomienda revisar dichas políticas."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "5. Tipos de Cookies Según su Duración"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cookies de sesión: Se eliminan automáticamente al cerrar el navegador o al cerrar sesión en la plataforma. Se usan para mantener activa la sesión durante el uso."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cookies persistentes: Permanecen almacenadas en el dispositivo durante un período definido. En AKLIO, las cookies persistentes tienen una duración máxima de doce (12) meses, tras los cuales se eliminan automáticamente o se renuevan si el usuario continúa usando la plataforma."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "6. Cookies que AKLIO NO Utiliza"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Declaramos expresamente que AKLIO no utiliza cookies para las siguientes finalidades:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Publicidad comportamental o retargeting con fines comerciales de terceros."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Creación de perfiles de usuarios con propósitos ajenos al servicio."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Venta, cesión o compartición de datos de navegación a redes publicitarias o agencias de marketing."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "7. Tratamiento de Datos Personales mediante Cookies"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Responsable del tratamiento: THE BLUE CODING S.A.S — AKLIO"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Finalidad: Según se especifica en cada tipo de cookie descrito en esta política."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Base legal: Consentimiento del usuario (Art. 7 LOPDP), salvo cookies técnicas necesarias para la prestación del servicio."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Conservación: Según se indica en el apartado de duración de cada tipo de cookie."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Comunicación a terceros: No se comunican datos a terceros, excepto cookies de terceros proveedores o por obligación legal."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Contacto para ejercicio de derechos: lopd@thebluecoding.com"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "8. Cómo Gestionar y Controlar las Cookies"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El usuario puede gestionar sus preferencias de cookies desde el panel de configuración de la plataforma o directamente desde la configuración de su navegador:"
                       },
                       {
                           "type":  "table",
                           "rows":  [
                                        [
                                            "Navegador",
                                            "Enlace para gestionar cookies"
                                        ],
                                        [
                                            "Google Chrome",
                                            "support.google.com/chrome/answer/95647"
                                        ],
                                        [
                                            "Mozilla Firefox",
                                            "mozilla.org/es-ES/privacy/websites/#cookies"
                                        ],
                                        [
                                            "Microsoft Edge",
                                            "support.microsoft.com — buscar \u0027cookies Edge\u0027"
                                        ],
                                        [
                                            "Safari (Mac/iOS)",
                                            "support.apple.com/es-es/guide/safari/sfri11471/mac"
                                        ],
                                        [
                                            "Opera",
                                            "help.opera.com/en/latest/security-and-privacy/"
                                        ]
                                    ]
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Tenga en cuenta que deshabilitar ciertas cookies necesarias puede afectar el correcto funcionamiento de la plataforma, incluyendo la imposibilidad de iniciar sesión o mantener la sesión activa."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "9. Derechos del Usuario"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El usuario tiene derecho a retirar su consentimiento en cualquier momento, así como a ejercer los derechos de acceso, rectificación, supresión, portabilidad y oposición respecto a los datos tratados mediante cookies. Para ejercer estos derechos, contacte a: lopd@thebluecoding.com"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "10. Actualizaciones a esta Política"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Esta Política de Cookies puede actualizarse cuando sea necesario para adaptarse a cambios en la plataforma, en los proveedores de servicios o en la normativa vigente. Cualquier cambio significativo será comunicado al usuario mediante aviso en la plataforma o por correo electrónico con al menos quince (15) días de anticipación."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "11. Contacto"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Delegado de Protección de Datos: lopd@thebluecoding.com"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Consultas generales: legal@thebluecoding.com"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Sitio web: https://thebluecoding.com/aklio"
                       }
                   ]
    },
    {
        "slug":  "acuerdo-procesamiento-datos",
        "navLabel":  "DPA",
        "title":  "Acuerdo de Procesamiento de Datos",
        "subtitle":  "Data Processing Agreement (DPA) conforme a la LOPDP Ecuador",
        "effectiveDate":  "30 de junio de 2025",
        "description":  "Acuerdo entre The Blue Coding como encargado y el usuario como responsable del tratamiento de datos.",
        "blocks":  [
                       {
                           "type":  "paragraph",
                           "text":  "El presente Acuerdo de Procesamiento de Datos (en adelante \"el DPA\") es parte integrante de los Términos y Condiciones de uso de AKLIO y regula la relación entre The Blue Coding (Encargado del Tratamiento) y el Usuario (Responsable del Tratamiento) respecto al procesamiento de datos personales de los pacientes registrados en la plataforma."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "1. Partes del Acuerdo"
                       },
                       {
                           "type":  "table",
                           "rows":  [
                                        [
                                            "Rol",
                                            "Identificación"
                                        ],
                                        [
                                            "Encargado del Tratamiento",
                                            "THE BLUE CODING S.A.S — AKLIO · lopd@thebluecoding.com"
                                        ],
                                        [
                                            "Responsable del Tratamiento",
                                            "El Usuario (médico, odontólogo o clínica) suscriptor de AKLIO, identificado en el contrato de servicio."
                                        ]
                                    ]
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El presente DPA entra en vigor en el momento en que el Usuario acepta los Términos y Condiciones de AKLIO y permanece vigente durante toda la duración de la relación contractual."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "2. Objeto del Procesamiento"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El Encargado procesará datos personales en nombre del Responsable con la única finalidad de prestar los servicios de gestión médica descritos en los Términos y Condiciones de AKLIO."
                       },
                       {
                           "type":  "table",
                           "rows":  [
                                        [
                                            "Aspecto",
                                            "Detalle"
                                        ],
                                        [
                                            "Categorías de datos",
                                            "Datos de identificación de pacientes, datos de salud (categoría especial/sensible), historial clínico, datos de contacto."
                                        ],
                                        [
                                            "Titulares de los datos",
                                            "Pacientes del Usuario."
                                        ],
                                        [
                                            "Finalidad del procesamiento",
                                            "Gestión de agenda médica y fichas clínicas digitales en la plataforma AKLIO."
                                        ],
                                        [
                                            "Duración",
                                            "Durante la vigencia del contrato de servicio y hasta la eliminación conforme a la política de conservación."
                                        ]
                                    ]
                       },
                       {
                           "type":  "paragraph",
                           "text":  "3. Obligaciones del Encargado (The Blue Coding)"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "The Blue Coding, como Encargado del Tratamiento, se compromete a:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Procesar los datos personales únicamente según las instrucciones documentadas del Responsable (el Usuario), salvo obligación legal contraria."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Garantizar que las personas autorizadas a tratar los datos hayan asumido compromisos de confidencialidad o estén sujetas a obligaciones legales de confidencialidad."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Implementar medidas técnicas y organizativas adecuadas para garantizar un nivel de seguridad apropiado al riesgo, conforme al Art. 37 de la LOPDP, incluyendo: cifrado de datos, control de acceso por roles, copias de seguridad y monitoreo de incidentes."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "No subcontratar ningún sub-encargado para el tratamiento de datos del Responsable sin informarle previamente y obtener su autorización expresa por escrito."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Asistir al Responsable en el cumplimiento de sus obligaciones respecto a los derechos ARCO+ de los titulares (pacientes), en la medida de lo técnicamente posible."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Notificar al Responsable sin demora indebida, y en todo caso dentro de las 72 horas siguientes al conocimiento, cualquier violación de seguridad que afecte a datos personales de los pacientes."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Proporcionar al Responsable toda la información necesaria para demostrar el cumplimiento de las obligaciones establecidas en la LOPDP."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "A elección del Responsable, suprimir o devolver todos los datos personales de los pacientes una vez finalizada la prestación de los servicios, y destruir las copias existentes, salvo que exista obligación legal de conservación."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "No utilizar los datos personales de los pacientes para fines propios, comerciales o distintos a los establecidos en este DPA."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "4. Obligaciones del Responsable (El Usuario)"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El Usuario, como Responsable del Tratamiento, se compromete a:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Haber obtenido el consentimiento válido de sus pacientes para el tratamiento de sus datos personales y de salud antes de ingresarlos en la plataforma."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Garantizar que los datos ingresados en la plataforma son exactos, pertinentes y no exceden la finalidad para la que fueron recabados."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Informar a sus pacientes sobre el uso de AKLIO como plataforma tecnológica para el almacenamiento de su información clínica."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Mantener la confidencialidad de las credenciales de acceso a la plataforma y no compartirlas con personas no autorizadas."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Notificar a The Blue Coding de inmediato ante cualquier indicio de brecha de seguridad que haya detectado en su entorno."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cumplir con todas las obligaciones que le corresponden como Responsable del Tratamiento conforme a la LOPDP y demás normativa aplicable."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "5. Subencargados del Tratamiento"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El Usuario autoriza a The Blue Coding a contratar sub-encargados (proveedores de infraestructura en la nube, servicios de almacenamiento, etc.) para la prestación del servicio. The Blue Coding garantiza que:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Los sub-encargados estarán sujetos a las mismas obligaciones de protección de datos establecidas en este DPA."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "The Blue Coding mantendrá una lista actualizada de sub-encargados disponible para consulta del Usuario a solicitud."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cualquier cambio en los sub-encargados será comunicado al Usuario con al menos treinta (30) días de antelación, otorgando al Usuario el derecho de oponerse de forma justificada."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "6. Transferencias Internacionales"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "En caso de que el procesamiento de datos implique transferencias fuera del Ecuador, The Blue Coding garantiza que dichas transferencias se realizan adoptando las salvaguardas contractuales y técnicas adecuadas conforme a la LOPDP, incluyendo cláusulas contractuales tipo cuando sea aplicable."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "7. Derechos de Auditoría"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El Responsable tiene derecho a auditar el cumplimiento de este DPA por parte del Encargado. Las auditorías se realizarán con previo aviso de al menos treinta (30) días, bajo confidencialidad y sin interferir en las operaciones de The Blue Coding. The Blue Coding podrá proporcionar certificaciones de auditoría de terceros como evidencia de cumplimiento."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "8. Violaciones de Seguridad"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "En caso de violación de seguridad que afecte datos personales de los pacientes:"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "The Blue Coding notificará al Responsable en el menor tiempo posible y dentro de las 72 horas siguientes al conocimiento del incidente."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La notificación incluirá: descripción de la naturaleza de la violación, categorías y número aproximado de titulares afectados, consecuencias probables y medidas adoptadas o propuestas para remediar la situación."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "El Responsable será quien evalúe la obligación de notificar a la APDP y a los titulares afectados, conforme a la LOPDP."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "9. Responsabilidad"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Cada parte será responsable de los daños causados por el incumplimiento de sus propias obligaciones bajo este DPA. The Blue Coding no será responsable por daños derivados del incumplimiento del Responsable de sus propias obligaciones bajo la LOPDP."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "La responsabilidad total de The Blue Coding bajo este DPA se limita a lo establecido en la cláusula de Limitación de Responsabilidad de los Términos y Condiciones."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "10. Vigencia y Terminación"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Este DPA permanece vigente durante toda la duración del contrato de servicios de AKLIO. A la terminación del contrato, The Blue Coding procederá conforme a lo establecido en la Política de Confidencialidad y en los Términos y Condiciones respecto a la retención y eliminación de datos."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "11. Legislación Aplicable"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Este DPA se rige por la Ley Orgánica de Protección de Datos Personales del Ecuador (LOPDP) y demás normativa aplicable. Cualquier controversia se resolverá conforme a lo establecido en los Términos y Condiciones de AKLIO."
                       },
                       {
                           "type":  "paragraph",
                           "text":  "12. Contacto"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Delegado de Protección de Datos: lopd@thebluecoding.com"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Consultas legales: legal@thebluecoding.com"
                       },
                       {
                           "type":  "paragraph",
                           "text":  "Sitio web: https://thebluecoding.com/aklio"
                       }
                   ]
    }
];

export const getAKLIOLegalDocument = (slug?: string) =>
  aklioLegalDocuments.find((document) => document.slug === slug);
